const colors = {
  greenDark: "#0E2426",
  green: "#132F34",
  orange: "#F6624E",
  white: "#EFEFEF",
}

export default colors
